import {
  ChoiceGroup,
  ComboBox,
  IComboBoxStyles,
  TextField,
} from "@fluentui/react";
import { FunctionComponent } from "react";
import HelpersIpercBase from "../../../utils/helpers/HelpersIpercBase";
import COLORES from "../../../utils/theme/colores";
import { TagDefault } from "../../../components/indicadores/Tags";

const gridContainerStyles = {
  display: "grid",
  gridTemplateColumns: "repeat(6, 1fr)",
  gridTemplateRows: "repeat(6, 1fr)",
  gridColumnGap: "5px",
  gridRowGap: "5px",
};

const divStyles = {
  div1: { gridArea: "6 / 1 / 7 / 6" ,padding:'0px 100px 0px 100px'},
  div2: { gridArea: "1 / 6 / 6 / 7" },
  div3: { gridArea: "1 / 1 / 6 / 6", padding:'50px 120px 50px 120px'},
};

const customStylesB: Partial<IComboBoxStyles> = {
  root: {
    maxWidth: "70px",
    // backgroundColor: COLORES.IPERC.A,
  },
  input: {
    // backgroundColor: COLORES.IPERC.A,
    //   color:COLORES.IPERC.B,
    fontWeight: "bold",
  },
  optionsContainerWrapper: {
    maxWidth: "70px",
  },
  label: {
    color: COLORES.IPERC.B,
  },
};
const customStyles: Partial<IComboBoxStyles> = {
    root: {
      maxWidth: "70px",
      // backgroundColor: COLORES.IPERC.A,
    },
    input: {
      // backgroundColor: COLORES.IPERC.A,
      color: COLORES.IPERC.A,
      fontWeight: "bold",
    },
    optionsContainerWrapper: {
      maxWidth: "70px",
    },
    label: {
      color: COLORES.IPERC.A,
      
    },
  };

interface EvaluacionesVistaProps {
  RiesgoId: string;
}

const EvaluacionesVista: FunctionComponent<EvaluacionesVistaProps> = () => {
  return (
    <>
      <div className="ms-Grid" dir="ltr">
        <TagDefault bodyMenssaje="Evaluacion de Riesgo" />
        <div style={gridContainerStyles}>
          <div style={divStyles.div1}>
            <ChoiceGroup
              name="riesgo"
              defaultSelectedKey="B"
              options={HelpersIpercBase.IPERC_CHOICE_OPTIONS_MATRIZ}
              styles={{ flexContainer: { display: "flex", marginLeft: 50 } }}
            />
          </div>
          <div style={divStyles.div2}>
            <ChoiceGroup
              defaultSelectedKey="B"
              options={[
                { key: "1", text: "1" },
                { key: "2", text: "2" },
                { key: "3", text: "3" },
                { key: "4", text: "4" },
                { key: "5", text: "5" },
              ]}
            />
          </div>
          <div style={divStyles.div3}>
            <TextField
              {...HelpersIpercBase.TextFieldNumberProps1}
              label="Valor de Riesgo"
              id="riesgo"
              name="Valor"
            />
          </div>
          {/* <div style={divStyles.div4}>Div 4</div> */}
        </div>
        <br />
        <TagDefault bodyMenssaje="Reevaluacion de Riesgo" />
        <div style={gridContainerStyles}>
          <div style={divStyles.div1}>
            <ChoiceGroup
              name="riesgo"
              defaultSelectedKey="B"
              options={HelpersIpercBase.IPERC_CHOICE_OPTIONS_MATRIZ}
              styles={{ flexContainer: { display: "flex", marginLeft: 50 } }}
            />
          </div>
          <div style={divStyles.div2}>
            <ChoiceGroup
              defaultSelectedKey="B"
              options={[
                { key: "1", text: "1" },
                { key: "2", text: "2" },
                { key: "3", text: "3" },
                { key: "4", text: "4" },
                { key: "5", text: "5" },
              ]}
            />
          </div>
          <div style={divStyles.div3}>
            <TextField
              {...HelpersIpercBase.TextFieldNumberProps1}
              label="Valor de Riesgo"
              id="riesgo"
              name="Valor"
            />
          </div>
          {/* <div style={divStyles.div4}>Div 4</div> */}
        </div>
        {/* <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-lg3"></div>
          <div className="ms-Grid-col ms-lg4"></div>
          <div className="ms-Grid-col ms-lg12"></div>
        </div> */}
        {/* <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-lg3">
            <ComboBox
              defaultSelectedKey="Calibri"
              label="Frecuencia"
              options={[
                { key: "A", text: "A" },
                { key: "B", text: "B" },
                { key: "C", text: "C" },
                { key: "D", text: "D" },
                { key: "E", text: "E" },
              ]}
              useComboBoxAsMenuWidth
              styles={customStyles}
            />
          </div>
          <div className="ms-Grid-col ms-lg4">
            <ComboBox
              defaultSelectedKey="Calibri"
              label="Severidad"
              options={[
                { key: "1", text: "1" },
                { key: "2", text: "2" },
                { key: "3", text: "3" },
                { key: "4", text: "4" },
                { key: "5", text: "5" },
              ]}
              useComboBoxAsMenuWidth
              styles={customStylesB}
            />
          </div>
          <div className="ms-Grid-col ms-lg15">
            <TextField
              {...HelpersIpercBase.TextFieldNumberProps1}
              label="Valor de Riesgo"
              id="riesgo"
              name="Valor"
            />
          </div>
        </div> */}
      </div>
    </>
  );
};

export default EvaluacionesVista;
